// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Assets_searchBar__P306n","inlineLabel":"Assets_inlineLabel__315eu","searchInput":"Assets_searchInput__2Gqn7","r20":"Assets_r20__p4X5l"};